import CryptoJS from 'crypto-js';
import { EncryptedDataRequest } from '../Models/EncryptedDataRequest';
export function getCurrentDate(separator = '') {
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${year}${separator}${
    month < 10 ? `0${month}` : `${month}`
  }${separator}${date}`;
}

export function formataData(data: any, separator = '', begin = 0) {
  var mes = data.getMonth();
  var ano = data.getFullYear();

  var daysInMonth = new Date(ano, mes, begin).getDate();

  if (mes.toString().length == 1) mes = '0' + mes;

  if (separator === '-') {
    return ano + separator + mes + separator + daysInMonth;
  } else if (separator === '/')
    return daysInMonth + separator + mes + separator + ano;
}

export function getCurrentMedia(qtdMonth: number, allRegister: number) {
  var result = allRegister / qtdMonth;
  return result;
}

export function parseRelatorioParams(params: any) {
  var parsedObject = params;

  parsedObject.dataInicial =
    parsedObject.dataInicial.toLocaleDateString('fr-CA');
  parsedObject.dataFinal = parsedObject.dataFinal.toLocaleDateString('fr-CA');

  return parsedObject;
}

export function validarCNPJ(cnpj: string): boolean {
    if (!cnpj) return false;

    // 1. Limpa a string: Remove tudo que N�O for letra ou n�mero e transforma em mai�scula
    cnpj = cnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    // 2. Verifica o tamanho do CNPJ (14)
    if (cnpj.length !== 14) return false;

    // 3. Verifica se todos os caracteres s�o iguais (ex: "00000000000000", "AAAAAAAAAAAAAA")
    if (/^([a-zA-Z0-9])\1{13}$/.test(cnpj)) return false;

    // 4. Os dois �ltimos d�gitos devem ser n�meros
    if (!/^\d{2}$/.test(cnpj.substring(12, 14))) return false;

    // 5. Pesos para o c�lculo do M�dulo 11
    const pesosPrimeiroDigito = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const pesosSegundoDigito = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    // C�LCULO DO 1� D�GITO VERIFICADOR
    let soma = 0;
    for (let i = 0; i < 12; i++) {
        //charCodeAt() pega o valor ASCII. Subtraindo 48, pega o valor real para o c�lculo.
        const valorChar = cnpj.charCodeAt(i) - 48;
        soma += valorChar * pesosPrimeiroDigito[i];
    }

    let resto = soma % 11;
    let digito1 = resto < 2 ? 0 : 11 - resto;

    // Valida o 1� d�gito calculado com o 1� d�gito verificador da string (posi��o 12)
    if (digito1 !== parseInt(cnpj.charAt(12), 10)) return false;

    // C�LCULO DO 2� D�GITO VERIFICADOR
    soma = 0;
    for (let i = 0; i < 13; i++) {
        const valorChar = cnpj.charCodeAt(i) - 48;
        soma += valorChar * pesosSegundoDigito[i];
    }

    resto = soma % 11;
    let digito2 = resto < 2 ? 0 : 11 - resto;

    // Valida o 2� d�gito calculado com o 2� d�gito verificador da string (posi��o 13)
    if (digito2 !== parseInt(cnpj.charAt(13), 10)) return false;

    // Se passou por todas as valida��es, o CNPJ � v�lido
    return true;
}

export function encryptData(data: any) {
  var message = JSON.stringify(data);
  var encrypted = window.btoa(message).toString();
  var dataEncrypted: EncryptedDataRequest = {
    Data: encrypted,
  };
  return dataEncrypted;
}
